export function getdata() {
	var obj = {
		mboptions: [{
				label: "标准模板",
				value: "0"
			},
			{
				label: "自定义模板",
				value: "1"
			}
		],
	}
	return obj
}
